/* globals lp, jui,Class */
module.exports = Class.create(
  lp.editor.panel.ElementPropertiesPanel,
  lp.editor.panel.ElementGeometryControls,
  lp.ModuleComponent,
  {
    type:'lp-code',

    initialize: function($super) {
      $super();
    },

    installUI: function($super) {
      $super();
      var self = this;

      this._uiBinding.subscribeDomainEvents(this.domainEvents, this);

      var editButtonPanel = this.insert(new jui.CollapsiblePanel({
        attributes: {
          className: 'collapsible-panel panel-html-edit no-label'
        }
      }));
      editButtonPanel.e.style.borderTop = 'none';
      editButtonPanel.titleBar.hide();
      this.controls.editButton = editButtonPanel.insertContent(new jui.Button({
        classNames : ['full-width-button'],
        label      : 'Edit Code',
        action     : function(){
          self._uiBinding.onNext({
            type: 'editCode'
          });
        }
      }));

      var geometryPanel = this.insert(new jui.CollapsiblePanel({
        title:'Geometry',
        attributes: {
          className: 'collapsible-panel panel-html-geometry'
        }
      }));
      this.installGeometryControls({insert:geometryPanel.insertContent.bind(geometryPanel)});
    },

    syncUIControls: function($super, elm) {
      $super(elm);
      this.bindGeometryControlsToElement(elm);
    },

    domainEvents: {
      editCode: function() {
        var self = this;
        this.getModule().openBuilder(self.element, {
          callback: function(data) {
            self.element.model.set('content.html', data.html, self.element.page.undoManager);
            self.element.model.set('content.valid', data.valid, self.element.page.undoManager);
            self.element.model.set('content.errors', data.errors, self.element.page.undoManager);
          }
        });
      }
    }
  }
);



//////////////////
// WEBPACK FOOTER
// ./src/legacy/lp/modules/lp-code/code_element_properties_panel.js
// module id = 1483
// module chunks = 0